var _excluded = ["children", "onClick", "full", "disabled", "inverted", "small", "secondary", "icon"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import { func, node, oneOfType, bool, string } from 'prop-types';
import StyledButton from './StyledButton';
/** Buttons make common actions more obvious and help users more easily perform them. Buttons use labels and sometimes icons to communicate the action that will occur when the user touches them. */

var Button = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      full = _ref.full,
      disabled = _ref.disabled,
      inverted = _ref.inverted,
      small = _ref.small,
      secondary = _ref.secondary,
      Icon = _ref.icon,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var finalProps = _extends({}, props);

  if (props.href) {
    finalProps.as = 'a';
  }

  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    ref: ref,
    disabled: disabled,
    full: full,
    inverted: inverted,
    onClick: onClick,
    small: small,
    secondary: secondary
  }, finalProps), Icon && /*#__PURE__*/React.createElement(Icon, null), children);
});
Button.propTypes = {
  children: node,
  disabled: bool,
  full: bool,
  inverted: bool,
  onClick: func,
  small: bool,
  secondary: bool,

  /** an Icon from yoga-icons package */
  icon: oneOfType([node, func]),
  href: string
};
Button.defaultProps = {
  children: 'Button',
  disabled: false,
  full: false,
  inverted: false,
  onClick: function onClick() {},
  small: false,
  secondary: false,
  icon: undefined,
  href: undefined
};
Button.displayName = 'Button';
export default Button;